import { Image } from 'react-native'
import { Images as foundationImages } from '@vfgroup-oneplatform/foundation/Components/Themes'

const Images = {
  ...foundationImages,
  // Icons
  bundle: Image.resolveAssetSource(require('../Images/Icons/bundle.png')),
  business_pass: Image.resolveAssetSource(require('../Images/Icons/business_pass.png')),
  chat_pass: Image.resolveAssetSource(require('../Images/Icons/chat_pass.png')),
  combo_pass: Image.resolveAssetSource(require('../Images/Icons/combo_pass.png')),
  data: Image.resolveAssetSource(require('../Images/Icons/data.png')),
  error: Image.resolveAssetSource(require('../Images/Icons/error.png')),
  gaming_pass: Image.resolveAssetSource(require('../Images/Icons/gaming_pass.png')),
  internet: Image.resolveAssetSource(require('../Images/Icons/internet.png')),
  internet_white: Image.resolveAssetSource(require('../Images/Icons/internet_white.png')),
  maps_pass: Image.resolveAssetSource(require('../Images/Icons/maps_pass.png')),
  minutes: Image.resolveAssetSource(require('../Images/Icons/minutes.png')),
  minutes_white: Image.resolveAssetSource(require('../Images/Icons/minutes_white.png')),
  music_pass: Image.resolveAssetSource(require('../Images/Icons/music_pass.png')),
  pega_bundle: Image.resolveAssetSource(require('../Images/Icons/pega_bundle.png')),
  remove: Image.resolveAssetSource(require('../Images/Icons/remove.png')),
  roaming: Image.resolveAssetSource(require('../Images/Icons/roaming.png')),
  sms: Image.resolveAssetSource(require('../Images/Icons/sms.png')),
  sms_white: Image.resolveAssetSource(require('../Images/Icons/sms_white.png')),
  social_pass: Image.resolveAssetSource(require('../Images/Icons/social_pass.png')),
  validity: Image.resolveAssetSource(require('../Images/Icons/validity.png')),
  video_pass: Image.resolveAssetSource(require('../Images/Icons/video_pass.png')),

  // Images
  third_image: Image.resolveAssetSource(require('../Images/Images/addon_image.png')),
  second_image: Image.resolveAssetSource(require('../Images/Images/main_bundle.png')),
  first_image: Image.resolveAssetSource(require('../Images/Images/roaming_image.png')),

  // HIFI
  creditcard: Image.resolveAssetSource(require('../Images/HIFI/creditcard@2x.png')),
  loan: Image.resolveAssetSource(require('../Images/HIFI/loan.png')),
  airtime: Image.resolveAssetSource(require('../Images/HIFI/airtime.png')),
  bill: Image.resolveAssetSource(require('../Images/HIFI/bill.png')),
  tick: Image.resolveAssetSource(require('../Images/HIFI/tick.png')),
}

export default Images
